import React, { useEffect, useState } from "react";
import {
  Col,
  Row, Input, Button,
  Popover,
  Layout,
  Radio,
  Skeleton,
  Table, Select, Pagination,
  DatePicker
} from "antd";
import dayjs from "dayjs";
import { FaSearch, FaFilter } from "react-icons/fa";
import { Get } from "../../config/api/get";
import { PAYMENT } from "../../config/constants";
import { useSelector } from "react-redux";

function PaymentLogs() {
  const token = useSelector((state) => state.user.userToken);
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);

  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);

  const [users, setUsers] = useState([]);
  const [users2, setUsers2] = useState([]);
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });

  const [paginationConfig2, setPaginationConfig2] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const [mode, setMode] = useState('subscription');
  const handleModeChange = (e) => {
    setMode(e.target.value);
  };


  const [filter, setFilter] = useState({
    status: null,
    keyword: "",
    from: null,
    to: null,
  });

  const [filter2, setFilter2] = useState({
    status: null,
    keyword: "",
    from: null,
    to: null,
  });

  const startIndex = (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const message = `Showing records ${endIndex} of ${paginationConfig.totalDocs}`;


  const startIndex2 = (paginationConfig2.pageNumber - 1) * paginationConfig2.limit + 1;
  const endIndex2 = Math.min(
    startIndex2 + paginationConfig2.limit - 1,
    paginationConfig2.totalDocs
  );
  const message2 = `Showing records ${endIndex2} of ${paginationConfig2.totalDocs}`;


  useEffect(() => {
    getPaymentLogs();
    getPaymentLogs2();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  

  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });

    getPaymentLogs(pageNumber);
  };

  const handlePageChange2 = (pageNumber) => {
    setPaginationConfig2({
      ...paginationConfig2,
      pageNumber: pageNumber,
    });

    getPaymentLogs2(pageNumber);
  };

  const handleSearch = (value) => {
    setFilter({
      ...filter,
      keyword: value,
    });
  };

  const handleSearch2 = (value) => {
    setFilter2({
      ...filter,
      keyword: value,
    });
  };

  const handleStatusChange = (value) => {
    setFilter({
      ...filter,
      status: value,
    });
  };

  const handleStatusChange2 = (value) => {
    setFilter2({
      ...filter2,
      status: value,
    });
  };

  const resetFilter = () => {
    setFilter({
      status: null,
      keyword: "",
      from: null,
      to: null,
    });
    getPaymentLogs(paginationConfig.pageNumber, paginationConfig.limit, "", true);
  };

  const resetFilter2 = () => {
    setFilter2({
      status: null,
      keyword: "",
      from: null,
      to: null,
    });
    getPaymentLogs2(paginationConfig2.pageNumber, paginationConfig2.limit, "", true);
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handleOpenChange2 = (newOpen) => {
    setOpen2(newOpen);
  };

  const handleFrom = (date) => {
    setFilter({
      ...filter,
      from: date,
    });
  };

  const handleTo = (date) => {
    setFilter({
      ...filter,
      to: date,
    });
  };

  const handleFrom2 = (date) => {
    setFilter2({
      ...filter2,
      from: date,
    });
  };

  const handleTo2 = (date) => {
    setFilter2({
      ...filter2,
      to: date,
    });
  };


  const handleLimitChange = (pageSize) => {
    setPaginationConfig({
      ...paginationConfig,
      limit: pageSize,
      current: 1,
    });

    getPaymentLogs(1, pageSize);
  };

  const handleLimitChange2 = (pageSize) => {
    setPaginationConfig2({
      ...paginationConfig2,
      limit: pageSize,
      current: 1,
    });

    getPaymentLogs2(1, pageSize);
  };

 
  const getPaymentLogs = async (pageNumber, pageSize, search, reset = false) => {
    setLoading(true);
    try {
      const response = await Get(PAYMENT.get, token, {
        page: pageNumber
          ? pageNumber.toString()
          : paginationConfig.pageNumber.toString(),
        limit: pageSize
          ? pageSize.toString()
          : paginationConfig.limit.toString(),
        status: reset ? "" : filter.status || null,
        keyword: search ? search : null,
        from: reset ? "" : filter?.from ? filter?.from.toISOString() : "",
        to: reset ? "" : filter?.to ? filter?.to.toISOString() : "",
      });
      setLoading(false);
      if (response?.status) {
        setUsers(response?.data?.docs);
        setPaginationConfig({
          pageNumber: response?.data?.page,
          limit: response?.data?.limit,
          totalDocs: response?.data?.totalDocs,
          totalPages: response?.data?.totalPages,
        });
      } else {
        message.error("Something went wrong!");
        console.log("error====>", response);
      }
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  };

  
  const getPaymentLogs2 = async (pageNumber, pageSize, search, reset = false) => {
    setLoading2(true);
    try {
      const response = await Get(PAYMENT.getAllContestPayments, token, {
        page: pageNumber
          ? pageNumber.toString()
          : paginationConfig2.pageNumber.toString(),
        limit: pageSize
          ? pageSize.toString()
          : paginationConfig2.limit.toString(),
        status: reset ? "" : filter.status || null,
        keyword: search ? search : null,
        from: reset ? "" : filter2?.from ? filter2?.from.toISOString() : "",
        to: reset ? "" : filter2?.to ? filter2?.to.toISOString() : "",
      });
      setLoading2(false);
      if (response?.status) {
        setUsers2(response?.data?.docs);
        setPaginationConfig2({
          pageNumber: response?.data?.page,
          limit: response?.data?.limit,
          totalDocs: response?.data?.totalDocs,
          totalPages: response?.data?.totalPages,
        });
      } else {
        message.error("Something went wrong!");
        console.log("error====>", response);
      }
    } catch (error) {
      console.log(error.message);
      setLoading2(false);
    }
  };

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return <button type="button">Previous</button>;
    }
    if (type === "next") {
      return <button type="button">Next</button>;
    }
    return originalElement;
  };

  const columns = [
    {
      title: "S. No.	",
      dataIndex: "key",
      key: "key",
      render: (value, item, index) => (index < 9 && "0") + (index + 1),
    },
    {
      title: "Lesson ID	",
      dataIndex: "lesson",
      key: "lesson",
      render: (value, item, index) => value?.lessonId,
    },
    {
      title: "Learner Name",
      dataIndex: "payee",
      key: "payee",
      render: (item) => item?.firstName + " " + item?.lastName,
    },
    {
      title: "Lesson Type",
      dataIndex: "lesson",
      key: "lesson",
      render: (item) => item?.lessonType,
    },
    {
      title: "Trainer/Consultant ID",
      dataIndex: "lesson",
      key: "lesson",
      render: (item) => item?.coach.coachId,
    },
    {
      title: "Trainer/Consultant Name",
      dataIndex: "lesson",
      key: "lesson",
      render: (item) => item?.coach.firstName + " " + item?.coach.lastName,
    },
    {
      title: "No of Lessons",
      dataIndex: "lesson",
      key: "lesson",
      render: (item) => item?.noOfLesson,
    },
    {
      title: "Lesson Date",
      dataIndex: "lesson",
      key: "lesson",
      render: (item) => <span>{dayjs(item.lessonDate).format("M/D/YYYY")}</span>,
    },
    {
      title: "Recieved Amount",
      dataIndex: "amount",
      key: "amount",
      render: (item) => <>${item}</>,
    },
    {
      title: "Receiving Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (item) => <span>{dayjs(item).format("M/D/YYYY")}</span>,
    },

   
  ];

  const columns2 = [
    {
      title: "S. No.	",
      dataIndex: "key",
      key: "key",
      render: (value, item, index) => (index < 9 && "0") + (index + 1),
    },
    {
      title: "USER NAME	",
      dataIndex: "payee",
      key: "payee",
      render: (value, item, index) => value?.fullName,
    },
    {
      title: "CONTEST NAME	",
      dataIndex: "contest",
      key: "contest",
      render: (value, item, index) => value?.title,
    },
    {
      title: "AMOUNT",
      dataIndex: "subscription",
      key: "subscription",
      render: (value, item, index) => <>${item?.amount}</>,
    },
    {
      title: "TRANSACTION DATE	",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (item) => <span>{dayjs(item).format("M/D/YYYY")}</span>,
    },   
  ];

  const filterContent = (
    <div className="filterDropdown">
      <div>
        <p className="mainLabel" style={{ padding: "10px" }}>
          Filter
        </p>
      </div>
      <hr style={{ margin: 0 }} />

      <div className="filterDropdownBody">
        <p className="mainLabel">Creation Date:</p>
        <DatePicker
          className="mainInput filterInput"
          value={filter.from}
          onChange={(e) => handleFrom(e)}
        />
        <DatePicker
          className="mainInput filterInput"
          value={filter.to}
          onChange={(e) => handleTo(e)}
        />

        <p className="mainLabel">Filter by Status:</p>

        <Select
          size={"large"}
          className="filterSelectBox"
          placeholder="Select Status"
          value={filter.status}
          onChange={(e) => handleStatusChange(e)}
          style={{
            width: "100%",
            marginBottom: "10px",
            textAlign: "left",
          }}
          options={[
            { value: "active", label: "Active" },
            { value: "inactive", label: "Inactive" },
          ]}
        />

        <Button
          type="primary"
          shape="round"
          block
          size={"large"}
          style={{ marginBottom: "10px" }}
          className="mainButton primaryButton"
          onClick={() => getPaymentLogs()}
        >
          Apply
        </Button>
        <Button
          type="primary"
          shape="round"
          block
          size={"large"}
          className="mainButton primaryButton2"
          onClick={() => resetFilter()}
        >
          Clear All
        </Button>
      </div>
    </div>
  );


  const filterContent2 = (
    <div className="filterDropdown">
      <div>
        <p className="mainLabel" style={{ padding: "10px" }}>
          Filter
        </p>
      </div>
      <hr style={{ margin: 0 }} />

      <div className="filterDropdownBody">
        <p className="mainLabel">Creation Date:</p>
        <DatePicker
          className="mainInput filterInput"
          value={filter2.from}
          onChange={(e) => handleFrom2(e)}
        />
        <DatePicker
          className="mainInput filterInput"
          value={filter2.to}
          onChange={(e) => handleTo2(e)}
        />

        <p className="mainLabel">Filter by Status:</p>

        <Select
          size={"large"}
          className="filterSelectBox"
          placeholder="Select Status"
          value={filter2.status}
          onChange={(e) => handleStatusChange2(e)}
          style={{
            width: "100%",
            marginBottom: "10px",
            textAlign: "left",
          }}
          options={[
            { value: "active", label: "Active" },
            { value: "inactive", label: "Inactive" },
          ]}
        />

        <Button
          type="primary"
          shape="round"
          block
          size={"large"}
          style={{ marginBottom: "10px" }}
          className="mainButton primaryButton"
          onClick={() => getPaymentLogs2()}
        >
          Apply
        </Button>
        <Button
          type="primary"
          shape="round"
          block
          size={"large"}
          className="mainButton primaryButton2"
          onClick={() => resetFilter2()}
        >
          Clear All
        </Button>
      </div>
    </div>
  );
  return (
    <Layout className="configuration">
      <div className="boxDetails2">
      <Row style={{ padding: "10px 20px",display:'flex',justifyContent:'space-between' }}>
          <h1 className="pageTitle">Payment Logs</h1>
          <Radio.Group
          className="radioSelector"
          size="large"
        onChange={handleModeChange}
        value={mode}
        style={{
          marginBottom: 8,
        }}
      >
        <Radio.Button value="subscription">Recieved Payment</Radio.Button>
        <Radio.Button value="contest">Paid Payment</Radio.Button>
      </Radio.Group>

        </Row>
      {mode ==="subscription" ? <div className="">
        

        <Row style={{ padding: "10px 20px" }}>
          <Col xs={24} md={12}>
            <h5 style={{ display: "inline", fontSize: 16 }}>Show : </h5>
            <Select
              size={"large"}
              className="chartSelectBox"
              defaultValue={paginationConfig.limit}
              onChange={(e) => handleLimitChange(e)}
              style={{
                width: 70,
                textAlign: "left",
              }}
              options={[
                { value: 10, label: "10" },
                { value: 20, label: "20" },
                { value: 30, label: "30" },
                { value: 40, label: "40" },
                { value: 50, label: "50" },
              ]}
            />
            &emsp;
            <h5 style={{ display: "inline", fontSize: 16 }}>Entries</h5>
          </Col>
          <Col
            xs={24}
            md={12}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Input
              style={{ width: "250px" }}
              className="mainInput dashInput"
              placeholder="Search"
              onChange={(e) => handleSearch(e.target.value)}
              suffix={
                <FaSearch
                  style={{
                    color: "#2484c6",
                    fontSize: 16,
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    getPaymentLogs(1, paginationConfig.limit, filter.keyword)
                  }
                />
              }
              onPressEnter={(e) =>
                getPaymentLogs(1, paginationConfig.limit, filter.keyword)
              }
            />
            &emsp;
            <Popover
              content={filterContent}
              trigger="click"
              open={open}
              onOpenChange={handleOpenChange}
              placement="bottomRight"
              arrow={false}
            >
              <Button
                style={{
                  padding: "10px 15px",
                  height: "auto",
                  backgroundColor: "#2484c6",
                }}
              >
                <FaFilter style={{ fontSize: "16px", color: "white" }} />
              </Button>
            </Popover>
          </Col>
        </Row>

        <Row style={{ padding: 20, overflow: "auto" }}>
          {loading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Skeleton active />
              <br />
            </div>
          ) : (<>
            <Table
              className="styledTable"
              dataSource={users}
              columns={columns}
              pagination={false}
            />
          </>
          )}
        </Row>
        <Row style={{ padding: "10px 20px" }}>
          <Col xs={24} md={12}>
            <p>{message}</p>
          </Col>
          <Col
            xs={24}
            md={12}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Pagination
              className="styledPagination"
              onChange={(e) => handlePageChange(e)}
              current={parseInt(paginationConfig.pageNumber)}
              pageSize={paginationConfig.limit}
              total={paginationConfig.totalDocs}
              itemRender={itemRender}
            />
          </Col>
        </Row>
        <br />
      </div> : <div className="">
        

        <Row style={{ padding: "10px 20px" }}>
          <Col xs={24} md={12}>
            <h5 style={{ display: "inline", fontSize: 16 }}>Show : </h5>
            <Select
              size={"large"}
              className="chartSelectBox"
              defaultValue={paginationConfig2.limit}
              onChange={(e) => handleLimitChange2(e)}
              style={{
                width: 70,
                textAlign: "left",
              }}
              options={[
                { value: 10, label: "10" },
                { value: 20, label: "20" },
                { value: 30, label: "30" },
                { value: 40, label: "40" },
                { value: 50, label: "50" },
              ]}
            />
            &emsp;
            <h5 style={{ display: "inline", fontSize: 16 }}>Entries</h5>
          </Col>
          <Col
            xs={24}
            md={12}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
            }}
          >
            <Input
              style={{ width: "250px" }}
              className="mainInput dashInput"
              placeholder="Search"
              onChange={(e) => handleSearch2(e.target.value)}
              suffix={
                <FaSearch
                  style={{
                    color: "#2484c6",
                    fontSize: 16,
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    getPaymentLogs2(1, paginationConfig2.limit, filter2.keyword)
                  }
                />
              }
              onPressEnter={(e) =>
                getPaymentLogs2(1, paginationConfig2.limit, filter2.keyword)
              }
            />
            &emsp;
            <Popover
              content={filterContent2}
              trigger="click"
              open={open2}
              onOpenChange={handleOpenChange2}
              placement="bottomRight"
              arrow={false}
            >
              <Button
                style={{
                  padding: "10px 15px",
                  height: "auto",
                  backgroundColor: "#2484c6",
                }}
              >
                <FaFilter style={{ fontSize: "16px", color: "white" }} />
              </Button>
            </Popover>
          </Col>
        </Row>

        <Row style={{ padding: 20, overflow: "auto" }}>
          {loading2 ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Skeleton active />
              <br />
            </div>
          ) : (<>
             <Table
            className="styledTable"
            dataSource={users2}
            columns={columns2}
            pagination={false}
          />
          </>
          )}
        </Row>
        <Row style={{ padding: "10px 20px" }}>
          <Col xs={24} md={12}>
            <p>{message2}</p>
          </Col>
          <Col
            xs={24}
            md={12}
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Pagination
              className="styledPagination"
              onChange={(e) => handlePageChange2(e)}
              current={parseInt(paginationConfig2.pageNumber)}
              pageSize={paginationConfig2.limit}
              total={paginationConfig2.totalDocs}
              itemRender={itemRender}
            />
          </Col>
        </Row>
        <br />
      </div>}
      </div>
      <br />
    
    </Layout>
  );
}

export default PaymentLogs;
